import React from 'react';
import { ClassAssembly5A2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly5A2026 />;
  };
  
  export default ClassAssemblyPage;